import * as z from 'zod/v4'

import {type CommandValueFor, createNamespacedActionCreator} from '../defineAction'

const createAction = createNamespacedActionCreator('learn')

const open = createAction('open', z.strictObject({mode: z.enum(['flashcards', 'quiz']).optional()}).optional())

export const learnActions = [open] as const

export const learnDescriptions = {
  learn_open:
    "Open the Learn panel for the current note. Pass mode only when the user asks to open or start Learn's " +
    'flashcards ("flashcards") or quiz ("quiz"), such as "start a quiz" or "study with flashcards"; omit it to open ' +
    'Learn home. A request to be asked questions here ("quiz me on this") is a read you answer in your reply.'
} satisfies Record<CommandValueFor<typeof learnActions>, string>
